import { Component, type ErrorInfo, type ReactNode } from "react";

export class SceneBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Showroom scene failed", error, info.componentStack);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="scene-error" role="status">
      <span>3D 内容暂时无法显示。</span>
      <button type="button" onClick={() => this.setState({ failed: false })}>重新加载</button>
    </div>;
  }
}
